/** @jsx jsx */
import { jsx } from "theme-ui"

import { vwoService } from "@trueskin-web/services"

import minusSvg from "./minusIcon.svg"

export const minusIcon = vwoService.isThemeRebrandedEnabled()
  ? minusSvg
  : {
      path: (
        <path
          d="M5 12h14"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="square"
          strokeLinejoin="round"
          fill="none"
        />
      ),
    }
